import { dashboards } from "../../../../shared/backend/controllers";
import { DashboardJobStatistics } from "./dashboardJobStatistics";

export const convertJobStatisticsResponse = (
    res: dashboards.JobStatisticsResponse
) => {
    if (!res) return;
    const result: DashboardJobStatistics = {
        avgFirstHireTimeInDays: res.avgFirstHireTimeInDays,
        avgFirstSubmitTimeInDays: res.avgFirstSubmitTimeInDays,
        avgTimeInSubmittedInDays: res.avgTimeInSubmittedInDays,
        closedAndFilledCount: res.closedAndFilledCount,
        closedAndNotFilledCount: res.closedAndNotFilledCount,
        hiredToRejectedPercentage: res.hiredToRejectedPercentage,
        interviewingToHiredPercentage: res.interviewingToHiredPercentage,
        notClosedWithEmptyPipelineCount: res.notClosedWithEmptyPipelineCount,
        notClosedWithFilledPipelineCount: res.notClosedWithFilledPipelineCount,
        submittedToInterviewingPercentage:
            res.submittedToInterviewingPercentage,
    };

    return result;
};
